module.exports = __webpack_public_path__ + "img/tri.c3647d9b.svg";